export default class DateUtils {
  static convertStringToDate (stringToConvert) {
    if (stringToConvert === null || !stringToConvert.trim()) {
      return '';
    }

    stringToConvert = stringToConvert.split('-');
    let day = parseInt(stringToConvert[2], 10);
    let month = parseInt(stringToConvert[1], 10);
    let year = parseInt(stringToConvert[0], 10);

    return new Date(year, month - 1, day, 12, 0, 0, 0);
  }

  static convertDateToString (rawDate) {
    if (rawDate === null || rawDate === '') {
      return '';
    }

    let day = 0;
    let month = 0;
    let year = 0;

    if (typeof rawDate !== 'string') {
      day = rawDate.getDate();
      month = rawDate.getMonth() + 1;
      year = rawDate.getFullYear();
    } else {
      rawDate = rawDate.split('T');
      rawDate = rawDate[0].split('-');
      day = parseInt(rawDate[2], 10);
      month = parseInt(rawDate[1], 10);
      year = parseInt(rawDate[0], 10);
    }

    if (day < 10) {
      day = '0' + day;
    }

    if (month < 10) {
      month = '0' + month;
    }

    return [year, month, day].join('-');
  }

  static groupConversionStringToDate (dataObject, fieldsToConvert) {
    dataObject = JSON.parse(JSON.stringify(dataObject));

    for (let i = 0; i < fieldsToConvert.length; i++) {
      let field = fieldsToConvert[i];
      dataObject[field] = DateUtils.convertStringToDate(dataObject[field]);
    }

    return dataObject;
  }

  static groupConversionDateToString (dataObject, fieldsToConvert) {
    dataObject = JSON.parse(JSON.stringify(dataObject));

    for (let i = 0; i < fieldsToConvert.length; i++) {
      let field = fieldsToConvert[i];
      dataObject[field] = DateUtils.convertDateToString(dataObject[field]);
    }

    return dataObject;
  }

  static getMonthShortName (monthIndex) {
    switch (monthIndex) {
      case 1: return 'JAN';
      case 2: return 'FEB';
      case 3: return 'MAR';
      case 4: return 'APR';
      case 5: return 'MAY';
      case 6: return 'JUN';
      case 7: return 'JUL';
      case 8: return 'AUG';
      case 9: return 'SEP';
      case 10: return 'OCT';
      case 11: return 'NOV';
      case 12: return 'DEC';
      default: return '';
    }
  }
}
